
import { Component, Prop, Vue } from 'nuxt-property-decorator'
import { OnMounted } from '~/core/vue.types'

@Component({})
export default class CollapseTruncateWrapper extends Vue implements OnMounted {
  @Prop({ required: false, default: true, type: Boolean })
  private readonly isCollapsible!: boolean

  @Prop({ required: true, default: false, type: Boolean })
  private readonly expanded!: boolean

  @Prop({ required: false, default: 0, type: Number })
  private readonly collapsedHeight!: number

  private isMounted = false

  get style () {
    if (!process.browser || !this.isMounted) {
      return
    }

    if (!this.$refs.collapseContent || !this.isCollapsible) {
      return
    }

    const { scrollHeight } = this.$refs.collapseContent as Element

    const collapsedHeight = this.collapsedHeight > scrollHeight ? scrollHeight : this.collapsedHeight
    const height = this.expanded ? scrollHeight : collapsedHeight

    return {
      height: String(height).concat('px'),
    }
  }

  mounted () {
    this.$nextTick(() => {
      this.isMounted = true
    })
  }
}
